import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const RiskClassTooltipContent = () => {
  return (
    <Box>
      <Typography component={'div'} variant={'body2'} sx={{ marginBottom: '10px' }} color={'white'}>
        Business Failure Risk Score is a metric used to assess the likelihood of a business failing within a specific
        period. It is typically derived from financial, operational, and market-related data, using statistical models
        or machine learning techniques. The score helps investors, lenders, and stakeholders evaluate a company's
        stability and make informed decisions regarding credit, investment, or risk management. Factors influencing the
        score may include revenue trends, profitability, liquidity, industry conditions, and macroeconomic factors.
      </Typography>
    </Box>
  )
}

export default RiskClassTooltipContent
